var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 75 75",
    style: {
      enableBackground: "new 0 0 75 75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#265d9e}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.3,33.5l-0.9,6.8c-0.1,1.1-1.1,2-2.3,2H41.1V71c-1.2,0.1-2.4,0.2-3.6,0.2c-2.7,0-5.3-0.3-7.8-0.8v-28h-8.5 c-0.8,0-1.4-0.6-1.4-1.4v-8.6c0-0.8,0.6-1.4,1.4-1.4h8.5V18.1c0-7.9,6.4-14.3,14.2-14.3h10c0.8,0,1.4,0.6,1.4,1.4v8.6 c0,0.8-0.6,1.4-1.4,1.4h-7.1c-3.1,0-5.7,2.6-5.7,5.7v10H53C54.4,31,55.4,32.2,55.3,33.5z",
    className: "st0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.2a50b6a44cf06399f0977448224d80aa.svg";
export { ForwardRef as ReactComponent };